import { RegistryItem } from "@schemas/agreements/schema";
import { BlockFreightSchema } from "@schemas/agreements/blockFreight.schema";
import { BunkerAdjustmentSchema } from "@schemas/agreements/bunkerAdjustment.schema";
import { CommissionSchema } from "@schemas/agreements/commission.schema";
import { DailySchema } from "@schemas/agreements/daily.schema";
import { DangerousGoodSchema } from "@schemas/agreements/dangerousGood.schema";
import { DeadfreightSchema } from "@schemas/agreements/deadfreight.schema";
import { DemurrageSchema } from "@schemas/agreements/demurrage.schema";
import { DemurrageCalculationSchema } from "@schemas/agreements/demurrageCalculation.schema";
import { FeetSchema } from "@schemas/agreements/feet.schema";
import { FreightSchema } from "@schemas/agreements/freight.schema";
import { GasolinePriceSchema } from "@schemas/agreements/gasolinePrice.schema";
import { GasolineSchema } from "@schemas/agreements/gasoline.schema";
import { SupplementaryHeatingSchema } from "@schemas/agreements/supplementaryHeating.schema";
import { HourlySchema } from "@schemas/agreements/hourly.schema";
import { LumpsumSchema } from "@schemas/agreements/lumpsum.schema";
import { OogSchema } from "@schemas/agreements/oog.schema";
import { PjkSchema } from "@schemas/agreements/pjk.schema";
import { ReeferSchema } from "@schemas/agreements/reefer.schema";
import { RentSchema } from "@schemas/agreements/rent.schema";
import { ShipSchema } from "@schemas/agreements/ship.schema";
import { TeuSchema } from "@schemas/agreements/teu.schema";
import { WaterwaySchema } from "@schemas/agreements/waterway.schema";
import { WaterLevelSchema } from "@schemas/agreements/waterLevel.schema";
import { WeightSchema } from "@schemas/agreements/weight.schema";
import { WeightRangeSchema } from "@schemas/agreements/weightRange.schema";
import { AddressCommissionSchema } from "@schemas/agreements/addressCommission.schema";
import { TextSchema } from "@schemas/agreements/text.schema";
import { PostCalculationSchema } from "@schemas/agreements/postCalculation.schema";
import { HoseRentalSchema } from "@schemas/agreements/hoseRental.schema";
import { NitrogenPurgingSchema } from "@schemas/agreements/nitrogenPurging.schema";
import { CleaningSchema } from "@schemas/agreements/cleaning.schema";
import { MultiCargoAdjustmentSchema } from "@schemas/agreements/multiCargoAdjustment.schema";
import { ReturnFreightDiscountSchema } from "@schemas/agreements/returnFreightDiscount.schema";
import { MultiOrderAdjustmentSchema } from "@schemas/agreements/multiOrderAdjustment.schema";


const SchemaRegistry: RegistryItem[] = [
	BlockFreightSchema,
	BunkerAdjustmentSchema,
	CommissionSchema,
	DailySchema,
	DangerousGoodSchema,
	DeadfreightSchema,
	DemurrageSchema,
	DemurrageCalculationSchema,
	FeetSchema,
	FreightSchema,
	GasolinePriceSchema,
	GasolineSchema,
	SupplementaryHeatingSchema,
	HourlySchema,
	LumpsumSchema,
	OogSchema,
	PjkSchema,
	ReeferSchema,
	RentSchema,
	ShipSchema,
	TeuSchema,
	WaterwaySchema,
	WaterLevelSchema,
	WeightSchema,
	WeightRangeSchema,
	AddressCommissionSchema,
	TextSchema,
	PostCalculationSchema,
	HoseRentalSchema,
	NitrogenPurgingSchema,
	CleaningSchema,
	MultiCargoAdjustmentSchema,
	ReturnFreightDiscountSchema,
	MultiOrderAdjustmentSchema,
];

export const AgreementSchema: RegistryItem = Object.assign({} as RegistryItem, ...SchemaRegistry) ;
